import React, {useEffect, useRef, useState} from "react";
import Slider from "react-slick";
import Styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import p1 from "../../theme/assets/other/tc_team_s2_p1.png";
import p2 from "../../theme/assets/other/tc_team_s2_p2.png";
import p3 from "../../theme/assets/other/tc_team_s2_p3.png";
import p4 from "../../theme/assets/other/tc_team_s2_p4.png";
import p5 from "../../theme/assets/other/tc_team_s2_p5.png";
import p6 from "../../theme/assets/other/tc_team_s2_p6.png";
import p7 from "../../theme/assets/other/tc_team_s2_p7.png";

import arrowL from "../../theme/assets/svg/tc_team_s2_arrow_r.svg";
import arrowR from "../../theme/assets/svg/tc_team_s2_arrow_l.svg";

import CustomBorder from "../_UI/customBorder";

const TeamS2 = () => {
    const { t } = useTranslation();
    const sliderRef = useRef(null);
    const [isMobile, setIsMobile] = useState(false);

    const items = [
        {img: p1, name: "Alrik Thornevald", position: "Founder & Vision Architect", note: t('Автор концепции цифрового продолжения личности. Отвечает за философию проекта, стратегическое развитие и архитектуру экосистемы.')},
        {img: p2, name: "Signe Valdoria", position: "Chief AI Officer", note: t('Алгоритмы моделирования личности, поведенческие нейросети, когнитивная реконструкция')},
        {img: p3, name: "Eldar Myrkvist", position: "Chief Cognitive Systems Researcher", note: t('Оцифровка личности, методология 200-вопросной модели, формирование цифрового профиля')},
        {img: p4, name: "Torvald Källbrink", position: "Chief Blockchain Architect", note: t('Токеномика $TC, смарт-контракты, дефляционная модель, экономическая устойчивость')},
        {img: p5, name: "Livia Stormhjelm", position: "Head of Virtual Civilization Design", note: t('Архитектура Future Meta Earth, автономной цифровой метавселенной')},
        {img: p6, name: "Ragnar Eklindor", position: "Chief Security & Cryptography Officer", note: t('Протоколы шифрования, децентрализованное хранение, защита цифрового наследия')},
        {img: p7, name: "Freja Norvind", position: "Ecosystem & Token Economy Strategist", note: t('Экономика личности, монетизация цифровых моделей, развитие комьюнити')},
    ];

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: isMobile ? 1 : 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "0px",
    };

    useEffect(() => {
        const checkIsMobile = () => {
            setIsMobile(window.innerWidth <= 1349);
        };

        checkIsMobile();
        window.addEventListener("resize", checkIsMobile);

        return () => window.removeEventListener("resize", checkIsMobile);
    }, []);

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={Styles.headWrap}>
                    <div className={Styles.title}>{t("Команда проекта")}</div>
                </div>

                <div className={Styles.sliderOuter}>
                    <div
                        onClick={() => sliderRef.current?.slickPrev()}
                        className={`${Styles.arrow} ${Styles.arrowLeft}`}
                    >
                        <img src={arrowL} alt="slide left"/>
                    </div>

                    <div className={Styles.sliderWrap}>
                        <Slider ref={sliderRef} {...settings}>
                            {items.map((item, index) => (
                                <div className={Styles.sliderItem} key={'tc-team' + index} >
                                    <div className={`${Styles.sliderItemContent} ${Styles.emptyCard}`}>
                                        <div className={`${Styles.imgWrap}`}>
                                            <img src={item.img} alt={item.name}/>
                                        </div>
                                        <div className={`${Styles.textWrap}`}>
                                            <CustomBorder corners={{ topRight: true, bottomLeft: true , topLeft: true, bottomRight: true}} cutSize={20} fill="#151729">
                                                <div className={`${Styles.textBox}`}>
                                                    <div className={`${Styles.textWrapName}`}>{item.name}</div>
                                                    <div className={`${Styles.textWrapPosition}`}>{item.position}</div>
                                                    <div className={`${Styles.textWrapNote}`}>{item.note}</div>
                                                </div>
                                            </CustomBorder>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>

                    <div
                        onClick={() => sliderRef.current?.slickNext()}
                        className={`${Styles.arrow} ${Styles.arrowRight}`}
                    >
                        <img src={arrowR} alt="slide right"/>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TeamS2;